import styles from "../aic.module.css";
import { useTableContext } from "./TableContextProvider";

interface AitBlankRowProps {
  id: string;
  border?: boolean;
}

/**
 * Render a blank spacer row used for borders and spacing.
 *
 * @param props - Component props
 * @param props.id - The row id
 * @param props.border - Render as a border row when true
 */
export const AitBlankRow = ({ id, border }: AitBlankRowProps) => {
  const { state } = useTableContext();
  const processedTableData = state?.processedTableData;
  const columnRepeats = processedTableData?.columnRepeats;
  const cis = columnRepeats ? Array.from(Array(columnRepeats.length).keys()) : undefined;

  return !cis ? null : (
    <tr id={id}>
      <td />
      {cis!.map((ci): React.ReactElement => (
        <td
          className={border ? styles.aitBorderCell : styles.aitSpaceCell}
          key={ci}
        />
      ))}
      <td />
    </tr>
  );
};

AitBlankRow.displayName = "AitBlankRow";
